import { CategoryConfigurableAttributes as AdvoxBasicCategoryConfigurableAttributes } from 'AdvoxBasicComponent/CategoryConfigurableAttributes/CategoryConfigurableAttributes.component';
import CategoryPriceSlider from 'Component/CategoryPriceSlider';
import ExpandableContent from 'Component/ExpandableContent';

import './CategoryConfigurableAttributes.extend.style';

/** @namespace AdvoxStrigob2c/Component/CategoryConfigurableAttributes/Component/CategoryConfigurableAttributes */
export class CategoryConfigurableAttributes extends AdvoxBasicCategoryConfigurableAttributes {
    renderPriceSwatch(option) {
        const { isContentExpanded, getSubHeading } = this.props;

        const { attribute_label, attribute_code, attribute_values } = option;

        const min = +attribute_values[0];
        const max = +attribute_values[1];

        return (
            <ExpandableContent
                key={attribute_code}
                heading={__(attribute_label)}
                subHeading={getSubHeading(option)}
                mix={{
                    block: 'ProductConfigurableAttributes',
                    elem: 'Expandable',
                }}
                isContentExpanded={isContentExpanded}
                isArrow
            >
                <CategoryPriceSlider min={min} max={max} />
            </ExpandableContent>
        );
    }

    renderDropdownOrSwatch(option) {
        const { isContentExpanded, getSubHeading } = this.props;

        const { attribute_label, attribute_code, attribute_options } = option;

        const [{ swatch_data }] = attribute_options ? Object.values(attribute_options) : [{}];
        const isSwatch = !!swatch_data;

        return (
            <ExpandableContent
                key={attribute_code}
                heading={attribute_label}
                subHeading={getSubHeading(option)}
                mix={{
                    block: 'ProductConfigurableAttributes',
                    elem: 'Expandable',
                }}
                isContentExpanded={isContentExpanded}
                isArrow
            >
                {isSwatch ? this.renderSwatch(option) : this.renderDropdown(option)}
            </ExpandableContent>
        );
    }
}

export default CategoryConfigurableAttributes;
